import { Flex } from '@chakra-ui/react'

export default function ReviewStepWrapper({
  children
}: {
  children: React.ReactNode
}) {
  return (
    <Flex
      flex={'1'}
      border={'solid 1px'}
      borderColor={'custom.gray.600'}
      borderRadius={'0.25rem'}
      p={'6'}
      gap={'6'}
      flexDirection={'column'}
      w={'full'}
    >
      {children}
    </Flex>
  )
}
